import { useAppDispatch, useAppSelector } from "app/hooks";
import { useEffect } from "react";

import { usePricingParcContext } from "../../contexts/PricingParcContext";
import { updateGlobalGuarantees } from "../../slices/pricing/pricingSlice";
import { selectGlobalGuaranteesReferential } from "../../slices/pricing/selectors/guaranteeFilterSelector";
import { buildSelectionFromConfigItems } from "../../slices/pricing/utils/parcGuaranteesUtils";

/**
 * Parc : réhydrate la sélection de garanties globales (Redux) depuis la couverture persistée
 * (config.global) à chaque (re)chargement du tarificateur. Sans ça, `fetchFunnels` repart toujours
 * avec `optional: []` et les garanties optionnelles enregistrées ne sont pas présélectionnées.
 * Ne rend rien.
 */
export const ParcGlobalGuaranteesHydrator: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isParc, config } = usePricingParcContext();
  const { globalGuaranteesReferential } = useAppSelector(selectGlobalGuaranteesReferential);

  const referentialReady =
    globalGuaranteesReferential.mandatory.length > 0 || globalGuaranteesReferential.optional.length > 0;

  useEffect(() => {
    if (!isParc || !config || !referentialReady) return;
    const selected = buildSelectionFromConfigItems(config.global, globalGuaranteesReferential);
    dispatch(updateGlobalGuarantees(selected));
  }, [isParc, config, globalGuaranteesReferential, referentialReady, dispatch]);

  return null;
};
